// extracted by mini-css-extract-plugin
export default {"pageSize":"pageSize_pageSize__V1de+3K9"};